/* eslint-disable */
import React, {useState,useEffect} from "react";
import { useDispatch } from 'react-redux'
import { Menu } from "antd";
import { getCategoryList } from "api/hub";
import { useTranslation } from 'react-i18next';

const LeftMenu = ({ mode }) => {
  const { i18n, t } = useTranslation()
  const dispatch = useDispatch()
  const [Categories, setCategories] = useState([]);
  useEffect(() => {
    dispatch(getCategoryList()).then(
      res => {
        // console.log(res.data)
        setCategories(res.data)
      }
    )
  }, []);
  return (
    <Menu mode={mode}>
      <Menu.Item key="explore">
        <a href="https://www.wiadvance.com/solutions-article/marketplace/" target="_blank" style={{fontSize:"16px", fontWeight:"400"}}>{t('Header.Explore')}</a>
      </Menu.Item>
      <Menu.SubMenu style={{fontSize:"16px", fontWeight:"400"}} title={<>{t('Header.Categories')}</>}>
        {
          Categories.map(item => {
            return <>
            <Menu.Item key={item.category_code}>
              <a style={{fontSize:"16px", fontWeight:"400"}} href={`/market/list?category=${item.category_code}`}>{localStorage.getItem('lang')==="tw"?item.category_name:item.category_name_en}</a>
            </Menu.Item>
            </>
          })
        } 
      </Menu.SubMenu>
      {/* <Menu.SubMenu title={<>{t('Header.Industries')}</>}>
        <Menu.Item key="1" style={{color:"black"}}>
           智慧製造
        </Menu.Item>
      </Menu.SubMenu> */}
    </Menu>
  );
};

export default LeftMenu;